/**
 * Responsive Component Exports
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

export { Responsive } from './component';
export type { ResponsiveProps } from './types';
